<template>
  <router-link id="logo-container" :to="navigate">
    <div
      :id="
        $vuetify.breakpoint.smAndDown
          ? 'fort-george-g-meade-small'
          : 'fort-george-g-meade'
      "
      class="grey--text text--darken-2 text-uppercase"
      :style="{ fontSize: $vuetify.breakpoint.smAndDown ? '8px' : '16px' }"
    >
      Fort George G. Meade
    </div>
    <div id="logo-sub-container" class="d-flex flex-row align-center">
      <img
        src="@/assets/shield.jpg"
        :height="$vuetify.breakpoint.smAndDown ? '50px' : '100px'"
      />
      <div
        :id="
          $vuetify.breakpoint.smAndDown
            ? 'resiliency-services-small'
            : 'resiliency-services'
        "
        class="secondary--text"
        :style="{ fontSize: $vuetify.breakpoint.smAndDown ? '24px' : '48px' }"
      >
        <div>Resiliency</div>
        <div>Services</div>
      </div>
    </div>
  </router-link>
</template>

<script>
import { mapState } from "vuex";
export default {
  computed: {
    ...mapState({ kioskMode: state => state.kioskMode }),
    navigate: function() {
      console.log(this.kioskMode);
      if (this.kioskMode) return { name: "Home" };
      else return { name: "Categories" };
    }
  }
};
</script>

<style scoped lang="less">
@import "../assets/global.less";

#header {
  white-space: nowrap;
  user-select: none;
  z-index: 10;
  #logo-container {
    display: flex;
    flex-direction: column;
    align-items: center;

    #fort-george-g-meade {
      margin-bottom: -4px;
      letter-spacing: 4px;
    }
    #fort-george-g-meade-small {
      margin-bottom: -2px;
      letter-spacing: 2px;
    }
    #logo-sub-container {
      #resiliency-services {
        font-weight: bold;
        div {
          text-align: left;
          margin-top: -28px;
          margin-bottom: -28px;
        }
      }
      #resiliency-services-small {
        font-weight: bold;
        div {
          text-align: left;
          margin-top: -14px;
          margin-bottom: -14px;
        }
      }
    }
  }
}

// remove underline from link in logo
a {
  text-decoration: none;
}
</style>
